import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './RegisterBtn.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonCirclePlus, faSignIn } from '@fortawesome/free-solid-svg-icons';

const RegisterBtn = () => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <>
      <button 
        className="register-floating-btn" 
        onClick={handleShow}
      >
        <FontAwesomeIcon icon={faPersonCirclePlus} className='px-2'/>
        Mon Compte
      </button>

      <Modal 
        show={showModal} 
        onHide={handleClose}
        centered
        className="auth-modal"
      >
        <Modal.Header closeButton>
          
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-4 py-4">
          <Button 
            variant="outline" 
            size="lg" 
            className="auth-btn"
            onClick={handleClose} 
          >
            <a style={null} target="_blank" href='https://client.youthfp.cm/login'><FontAwesomeIcon icon={faSignIn} />Se Connecter</a>
          </Button>
          <Button 
            variant="outline" 
            size="lg" 
            className="auth-btn"
            onClick={handleClose} 
          >
            <a style={null} href='/register'><FontAwesomeIcon icon={faPersonCirclePlus} />Créer un compte</a>
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RegisterBtn;